import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import config from '../config';
import { useExternalSubmissionUpdater } from '../context/ExternalSubmissionContext';

const axiosInstance = axios.create({
	baseURL: config.feedbackApi.baseUrl,
	headers: {
		timeout: '60000',
	},
});

const feedbackKeys = {
	all: ['externalSubmission'],
	feedback: (id) => [...feedbackKeys.all, id],
};

export function useGetFeedbackForm() {
	const urlParams = new URLSearchParams(window.location.search);

	const feedbackRequestId = urlParams.get('id');

	return useQuery({
		queryKey: feedbackKeys.feedback(feedbackRequestId),
		staleTime: Infinity,
		queryFn: async () => {
			const response = await axiosInstance.get(`/v1/api/email?linkId=${feedbackRequestId}`);
			return response.data;
		},
		select: (feedback) => {
			const initialResponses = feedback.formCard.body
				.filter(({ type }) => type !== 'TextBlock')
				.map(({ id, value }) => ({
					id,
					value: value || '',
				}));
			return { ...feedback, initialResponses };
		},
	});
}

export function useSubmitFeedback() {
	const { showStatus } = useExternalSubmissionUpdater();

	return useMutation({
		mutationFn: async (feedback) => {
			const response = await axiosInstance.post('/v1/api/email', feedback);
			return response.data;
		},
		onMutate: () => {
			showStatus({
				isSubmitting: true,
			});
		},
		onError: () => {
			showStatus({
				isSubmitError: true,
			});
		},
		onSuccess: () => {
			showStatus({
				isSubmitSuccess: true,
			});
		},
	});
}

export function useSaveFeedbackDraft() {
	const { showStatus } = useExternalSubmissionUpdater();

	return useMutation({
		mutationFn: async (feedback) => {
			const response = await axiosInstance.post('/v1/api/email', feedback);
			return response.data;
		},
		onMutate: () => {
			showStatus({
				isSaving: true,
			});
		},
		onError: () => {
			showStatus({
				isSaveError: true,
			});
		},
		onSuccess: () => {
			showStatus({
				isSaveSuccess: true,
			});
		},
	});
}
